export interface Manga {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  latestChapter: string;
  updatedAt: string;
  chapters: number;
}

export const mangaList: Manga[] = [
  {
    id: 1,
    title: '洞洞杂货铺',
    author: '墨染青衫',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20cozy%20mysterious%20corner%20store%20at%20night%2C%20warm%20light%20spilling%20from%20windows%2C%20various%20magical%20items%20displayed%2C%20anime%20art%20style%2C%20rich%20colors%2C%20soft%20atmospheric%20lighting%2C%20Japanese%20manga%20cover%20aesthetic&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    category: 'qihuan',
    description: '在一家不起眼的小巷深处，有一间名为「洞洞杂货铺」的神秘小店。店主是一位看似普通的青年，但店里售卖的商品都拥有不可思议的力量。每一个走进杂货铺的顾客，都将经历一段改变命运的奇妙旅程。',
    status: '连载中',
    rating: 9.6,
    views: 12800000,
    latestChapter: '第87话 命运的选择',
    updatedAt: '2026-08-04',
    chapters: 87,
  },
  {
    id: 2,
    title: '星辰大海',
    author: '星河漫步',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20with%20a%20young%20astronaut%20floating%20in%20deep%20space%2C%20colorful%20nebula%20background%2C%20stars%20and%20galaxies%2C%20anime%20art%20style%2C%20vibrant%20colors%2C%20dreamy%20atmosphere%2C%20manga%20cover%20design&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    category: 'kehuan',
    description: '公元2150年，人类已经进入星际殖民时代。少年林星辰在一次意外中获得了与星辰沟通的能力，从此踏上了探索宇宙奥秘的征途。',
    status: '连载中',
    rating: 9.3,
    views: 8600000,
    latestChapter: '第124话 黑洞彼端',
    updatedAt: '2026-08-03',
    chapters: 124,
  },
  {
    id: 3,
    title: '修真聊天群',
    author: '圣骑士的传说',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20showing%20a%20modern%20young%20man%20holding%20a%20smartphone%20with%20magical%20glowing%20runes%2C%20ancient%20Chinese%20cultivation%20elements%20mixed%20with%20modern%20city%20background%2C%20anime%20art%20style%2C%20dynamic%20composition&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    category: 'rexue',
    description: '某天，宋书航意外加入了一个仙侠中二病资深患者的交流群，里面的群友们都以「道友」相称。然而他很快发现——群里的人，好像全部都是真正的修真者！',
    status: '连载中',
    rating: 9.5,
    views: 15600000,
    latestChapter: '第312话 天劫降临',
    updatedAt: '2026-08-04',
    chapters: 312,
  },
  {
    id: 4,
    title: '月色真美',
    author: '春日暖阳',
    cover: 'https://readdy.ai/api/search-image?query=A%20romance%20manga%20cover%20with%20a%20boy%20and%20girl%20sitting%20under%20a%20cherry%20blossom%20tree%20at%20sunset%2C%20soft%20pink%20and%20warm%20golden%20tones%2C%20gentle%20atmosphere%2C%20anime%20art%20style%2C%20sweet%20and%20tender%20feeling&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    category: 'lianai',
    description: '高中二年级的夏天，内向的男生周月白遇见了活泼开朗的转校生林夕。两人从相识到相知，一段青涩而美好的校园恋爱故事就此展开。',
    status: '已完结',
    rating: 9.2,
    views: 7200000,
    latestChapter: '第96话 永远',
    updatedAt: '2026-06-15',
    chapters: 96,
  },
  {
    id: 5,
    title: '爆笑校园',
    author: '笑林广记',
    cover: 'https://readdy.ai/api/search-image?query=A%20comedy%20manga%20cover%20showing%20a%20classroom%20full%20of%20students%20with%20exaggerated%20funny%20expressions%2C%20bright%20colorful%20style%2C%20cartoonish%20anime%20art%2C%20energetic%20and%20playful%20vibe%2C%20school%20setting&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    category: 'gaoxiao',
    description: '在一所普通的中学里，有一群不普通的学生。学霸的崩溃日常、老师的无奈时刻、课间的疯狂打闹……每一页都让你笑到停不下来！',
    status: '连载中',
    rating: 8.9,
    views: 9500000,
    latestChapter: '第201话 食堂大作战',
    updatedAt: '2026-08-02',
    chapters: 201,
  },
  {
    id: 6,
    title: '暗夜侦探',
    author: '墨色深蓝',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystery%20manga%20cover%20with%20a%20detective%20in%20trench%20coat%20standing%20in%20a%20dark%20alley%20under%20streetlight%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20anime%20art%20style%2C%20mysterious%20and%20tense%20mood&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    category: 'xuanyi',
    description: '连环杀人案、密室失踪、完美不在场证明……天才侦探顾夜明凭借超凡的推理能力，一次次揭开案件背后的惊人真相。',
    status: '连载中',
    rating: 9.4,
    views: 6800000,
    latestChapter: '第58话 最后的拼图',
    updatedAt: '2026-08-01',
    chapters: 58,
  },
  {
    id: 7,
    title: '异世界悠闲日常',
    author: '午后红茶',
    cover: 'https://readdy.ai/api/search-image?query=A%20slice%20of%20life%20manga%20cover%20set%20in%20a%20fantasy%20world%20countryside%2C%20a%20girl%20tending%20a%20magical%20garden%20with%20cute%20creatures%2C%20warm%20pastel%20colors%2C%20anime%20art%20style%2C%20peaceful%20and%20healing%20vibe&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    category: 'richang',
    description: '平凡的上班族意外穿越到异世界，没有拯救世界的重任，没有复杂的人际关系，只有一间小屋、一片菜地，和一群可爱的邻居。最治愈的异世界慢生活！',
    status: '连载中',
    rating: 9.1,
    views: 5400000,
    latestChapter: '第143话 丰收祭',
    updatedAt: '2026-08-03',
    chapters: 143,
  },
  {
    id: 8,
    title: '剑道至尊',
    author: '铁骨',
    cover: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20manga%20cover%20with%20a%20swordsman%20in%20traditional%20Chinese%20robe%20holding%20a%20glowing%20sword%2C%20ancient%20Chinese%20mountain%20landscape%2C%20dynamic%20action%20pose%2C%20anime%20art%20style%2C%20epic%20atmosphere&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    category: 'rexue',
    description: '少年叶凡出身寒门，却怀揣着一颗成为最强剑客的心。在弱肉强食的修真世界，他凭借不屈的意志和一把断剑，一步步登上剑道之巅。',
    status: '连载中',
    rating: 9.0,
    views: 11200000,
    latestChapter: '第267话 剑意通天',
    updatedAt: '2026-08-04',
    chapters: 267,
  },
  {
    id: 9,
    title: '深夜食堂',
    author: '午夜厨房',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20of%20a%20small%20cozy%20Japanese%20restaurant%20at%20night%2C%20warm%20yellow%20light%20inside%2C%20chef%20cooking%20behind%20counter%2C%20anime%20art%20style%2C%20nostalgic%20and%20comforting%20atmosphere&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    category: 'richang',
    description: '城市的一角，有一间只在深夜营业的小食堂。来这里的人各有各的故事，而老板用一道道简单的料理，温暖着每一个深夜的灵魂。',
    status: '连载中',
    rating: 9.3,
    views: 6100000,
    latestChapter: '第89话 妈妈的味道',
    updatedAt: '2026-08-02',
    chapters: 89,
  },
  {
    id: 10,
    title: '诡秘之主',
    author: '灵异行者',
    cover: 'https://readdy.ai/api/search-image?query=A%20horror%20manga%20cover%20with%20a%20figure%20in%20Victorian%20era%20clothing%20surrounded%20by%20supernatural%20shadows%2C%20dark%20gothic%20atmosphere%2C%20clock%20tower%20in%20background%2C%20anime%20art%20style%2C%20eerie%20and%20mysterious&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    category: 'kongbu',
    description: '在一个蒸汽与机械的时代，隐藏着不为人知的超凡世界。周明瑞意外获得了窥见诡秘的能力，他必须在理智与疯狂的边缘，探寻这个世界的终极秘密。',
    status: '连载中',
    rating: 9.7,
    views: 18900000,
    latestChapter: '第198话 古神的低语',
    updatedAt: '2026-08-04',
    chapters: 198,
  },
  {
    id: 11,
    title: '我的女友是九尾狐',
    author: '月下传说',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20romance%20manga%20cover%20with%20a%20beautiful%20girl%20with%20fox%20ears%20and%20nine%20tails%20in%20modern%20city%20setting%2C%20magical%20sparkles%2C%20anime%20art%20style%2C%20charming%20and%20enchanting%20atmosphere&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    category: 'lianai',
    description: '普通大学生李然偶然救下了一只受伤的白狐，没想到它竟是修炼千年的九尾狐妖。为了报恩，她化为人形住进了李然的公寓，一段跨种族之恋就此展开。',
    status: '连载中',
    rating: 9.0,
    views: 7800000,
    latestChapter: '第76话 真心',
    updatedAt: '2026-08-03',
    chapters: 76,
  },
  {
    id: 12,
    title: '魔王学院的不适合者',
    author: '魔王再临',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20cover%20with%20a%20powerful%20demon%20king%20in%20school%20uniform%2C%20magical%20academy%20background%2C%20dark%20and%20golden%20color%20scheme%2C%20anime%20art%20style%2C%20imposing%20and%20cool%20atmosphere&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    category: 'qihuan',
    description: '曾经统治世界的暴虐魔王，厌倦了打打杀杀之后转生到了两千年后的和平时代。然而魔王学院的入学考试中，他却被打上了「不适合者」的标签……',
    status: '连载中',
    rating: 9.1,
    views: 10300000,
    latestChapter: '第156话 魔王归来',
    updatedAt: '2026-08-04',
    chapters: 156,
  },
];

export const featuredMangaIds = [1, 3, 10, 4, 6];

export const hotMangaIds = [10, 1, 3, 8, 6, 4, 9, 12];

export const latestMangaIds = [1, 3, 8, 10, 7, 12, 5, 9, 11, 2, 6, 4];